import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Home, ArrowLeft, Search } from 'lucide-react';

const NotFound: React.FC = () => {
  useEffect(() => {
    document.title = 'Page Non Trouvée | Proxy Emobility';
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 pt-20">
      <Helmet>
        <title>Page Non Trouvée | Proxy Emobility</title>
        <meta name="description" content="La page que vous recherchez n'existe pas ou a été déplacée." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      <div className="text-center max-w-lg">
        <h1 className="text-9xl font-bold text-primary-600 mb-6">404</h1>
        <h2 className="text-3xl font-bold text-gray-900 mb-4">Page Non Trouvée</h2>
        <p className="text-lg text-gray-600 mb-8">
          La page que vous recherchez a peut-être été supprimée, renommée ou est temporairement indisponible.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            to="/" 
            className="px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-medium rounded-md inline-flex items-center justify-center transition-colors"
          >
            <Home size={18} className="mr-2" />
            Retour à l'accueil
          </Link>
          <Link 
            to="/contact" 
            className="px-6 py-3 border border-gray-300 text-gray-700 hover:bg-gray-50 font-medium rounded-md inline-flex items-center justify-center transition-colors"
          >
            <Search size={18} className="mr-2" />
            Besoin d'aide ?
          </Link>
        </div>
        
        <div className="mt-12">
          <Link 
            to="javascript:history.back()" 
            className="inline-flex items-center text-primary-600 hover:text-primary-700"
          >
            <ArrowLeft size={16} className="mr-2" />
            Retour à la page précédente
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;